import { render, staticRenderFns } from "./forgotten-password.vue?vue&type=template&id=26f358e6&"
import script from "./forgotten-password.ts?vue&type=script&lang=ts&"
export * from "./forgotten-password.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports